/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Portal API Gateway
 * OpenAPI spec version: 2.0.0
 */

/**
 * type of fuel
 */
export type FuelType = (typeof FuelType)[keyof typeof FuelType]

export const FuelType = {
  DUAL_FUEL: "DUAL_FUEL",
  GAS_ONLY: "GAS_ONLY",
  ELECTRICITY_ONLY: "ELECTRICITY_ONLY",
} as const
